<ng-container *featureFlag="featureFlagsEnum.VIEW_SECTION_BREADCRUMBS" >
 @if (show && !conceptService.loadingErrorMessage()) {
     <div *ngIf="!isEditing" class="breadcrumb-cont">
        <div class="breadcrumb-inner">
          <span *ngIf="!loading else loadingSkeleton" (dblclick)="onEditTitle('project')" class="pointer" [cyData]="'breadcrumbs-project-title'">{{ projectTitle }} </span>
          <span>/</span>
          <span *ngIf="!loading else loadingSkeleton" (dblclick)="onEditTitle('branch')" class="pointer" [cyData]="'breadcrumbs-concept-title'">{{ branchTitle }}</span>
        </div>
      </div>
      <div *ngIf="isEditing" class="breadcrumb-cont">
        <awc-input
          class="breadcrumb-edit"
          (keydown.enter)="finishEditing()"
          (keydown.esc)="cancelEditing()"
          (click)="$event.stopPropagation()"
          [(value)]="editValue"
          (valueChange)="editValue = $event.toString()"
        ></awc-input>
        <div class="overlay" *ngIf="isEditing" (click)="finishEditing()"></div>
      </div>

    <ng-template #loadingSkeleton>
      <awc-loading-skeleton
        [width]="width"
        [lineHeight]="lineHeight"
        [type]="type"
      ></awc-loading-skeleton>
    </ng-template>
  }
</ng-container>

